import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Button,
  CloseButton,
  Alert,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import "../styles/AuthModal.css";
import { passwordReset } from "../Api/authApi";

const ForgotPasswordModal = ({ show, handleClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Reset form data when modal is closed
  useEffect(() => {
    if (!show) {
      setEmail("");
      setError("");
      setLoading(false);
    }
  }, [show]);

  // Handle input change
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await passwordReset(email);
      toast.success("Password reset link sent to your email!");
      handleClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal-size"
    >
      <Modal.Body className="auth-modal-body">
        <CloseButton onClick={handleClose} className="close-btn" />

        <div className="heading text-center mb-4">
          <h1 className="title">Forgot Password</h1>
          <h5 className="subtitle">
            Enter your email address and we'll send you a link to reset your password.
          </h5>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              onChange={handleChange}
              value={email}
              required
            />
          </Form.Group>

          <Button
            type="submit"
            className="btn-gradient w-100 mb-3"
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : "Send Reset Link"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPasswordModal;